// @flow
import React from 'react';
import ListItemText from "@mui/material/ListItemText";
import {Switch} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import type {Exhibition} from "../../../../../../types/exhibition/types";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../../../../locales/components/namespaces";
import {Update} from "../../../../../../hooks/exhibitions/useExhibitionAction";

type Props = {
    id: string,
    exhibition: Exhibition,
    updateExhibition: Function
};

const ExhibitorHasScanning = (props: Props) => {
    const {t} = useTranslation(EXHIBITION)
    const {id, exhibition, updateExhibition} = props

    const toggle = () => {
        updateExhibition(id, !exhibition.hasExhibitorScanning, Update.hasExhibitorScanning)
    }
    return (
        <ListItem>
            <ListItemText
                primary={t('Allow Exhibitor To Scan Visitors')}
                secondary={t('If you enable this, selected exhibitors will be able to scan visitors from their kiosk.')}
            />
            <Switch
                edge="end"
                onChange={toggle}
                checked={exhibition.hasExhibitorScanning}
            />
        </ListItem>
    );
};

export default ExhibitorHasScanning